import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoteDetalleUrlCoordenadaService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'lotes/detalles/urls'); // La URL base para el servicio de usuarios
  }

  addCoordenadasCertificante(idLoteDetalleUrl: number, body: any): Observable<any> {
    return this.post<any>(body, `${idLoteDetalleUrl}/coordenadas`);
  }

  addCoordenadasGrupo(idLoteDetalleUrl: number, body: any): Observable<any> {
    return this.post<any>(body, `${idLoteDetalleUrl}/coordenadas/grupos`);
  }

  listDetalleUrlCoordenadas(documentId: number) {
    return this.get<any>({
       endpoint: `${documentId}/coordenadas`
    });
  }

  listDetalleUrlCoordenadasGrupo(documentId: number) {
    return this.get<any>({
       endpoint: `${documentId}/coordenadas/grupos`
    });
  }

  deleteCoordenada(loteDetalleUrlId: number, loteDetalleUrlCoordenadaId: number) {
    return this.delete<any>(`${loteDetalleUrlId}/coordenadas/${loteDetalleUrlCoordenadaId}`);
  }

  showDetalleUrl(loteId: number, loteDetalleUrlId) {
    return this.get<any>({
       endpoint: `${loteId}/detalles/urls/${loteDetalleUrlId}`
    });
  }
}